import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import classes from './NavigationTop.module.scss';
import { useTranslation } from 'react-i18next';

export const NavigationTop = () => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const [isLanguageReady, setIsLanguageReady] = useState(false);

  // パスから期待される言語を取得
  const pathSegments = location.pathname.split('/').filter(segment => segment !== '');
  const expectedLanguage = pathSegments[0] || 'ja';

  useEffect(() => {
    const handleLanguageChange = (lng: string) => {
      if (lng === expectedLanguage) {
        setIsLanguageReady(true);
      }
    };
    if (i18n.language === expectedLanguage) {
      setIsLanguageReady(true);
    }
    i18n.on('languageChanged', handleLanguageChange);
    return () => { i18n.off('languageChanged', handleLanguageChange); };
  }, [expectedLanguage]);

  if (!isLanguageReady) return null;

  return (
    <nav className={classes.headerBar}>
      <a className={classes.hadoLogo} href={i18n.language === 'en' ? 'https://hado-official.com/en/' : 'https://hado-official.com/'}>
        <img src="https://hado-official.com/wp-content/themes/hado-official-theme/assets/img/common/logo.png" alt="HADO" />
      </a>

      <ul className={classes.navMenu}>
        <li className={`${classes.menuItem} ${classes.iconOnly}`}>
          <a href="https://twitter.com/hado_info" target="_blank" rel="noopener noreferrer" aria-label="X">
            <i className="fa-brands fa-x-twitter" />
          </a>
        </li>
        <li className={`${classes.menuItem} ${classes.iconOnly}`}>
          <a href="https://www.youtube.com/channel/UC2alHTyXjiwe_aRFWq3N-Hw" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <i className="fa-brands fa-youtube" />
          </a>
        </li>
        <li className={`${classes.menuItem} ${classes.iconOnly}`}>
          <a href="https://facebook.com/HADO-1376721975970182" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <i className="fa-brands fa-square-facebook" />
          </a>
        </li>
        <li className={`${classes.menuItem} ${classes.iconOnly}`}>
          <a href="https://www.instagram.com/hado__info/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <i className="fa-brands fa-instagram" />
          </a>
        </li>

        <li className={classes.storeBtn}>
          <a href="https://hado-official.com/arena/">
            <i className="fa-solid fa-store" /> 店舗一覧・ご予約
          </a>
        </li>
      </ul>
    </nav>
  );
};
